const $ = window.jQuery;

/**
 * Enables 'AdvancedCustomFields' plugin specific scripting
 */
const AdvancedCustomFields = {

    /**
     * Initialise functionality
     */
    init()
    {

        this.alterDatePickers();
        this.alterHTMLDropdowns();

    },

    /**
     * Adjust jQuery datepicker arguments for relative min and max dates
     * @returns void
     */
    alterDatePickers()
    {

        // Skip if ACF isn't loaded
        if (typeof acf == 'undefined' || !acf) {
            return;
        }

        // Adjust jQuery datepicker arguments for relative min and max dates
        acf.add_filter('date_picker_args', this.alterPickerArgs);
        acf.add_filter('date_time_picker_args', this.alterPickerArgs);

        // Alter elements for placeholders
        acf.add_action('load', this.applyPickerPlaceholders);

    },

    /**
     * Alter select2 dropdowns for icons and colours
     * @returns void
     */
    alterHTMLDropdowns()
    {
        // Skip if ACF isn't loaded
        if (typeof acf == 'undefined' || !acf) {
            return;
        }

        acf.add_filter('select2_escape_markup', this.escapeHTMLDropdownMarkup);
    },

    /**
     * Alter jQuery date picker args for a relative date
     *
     * @param {array} args jQuery datepicker args
     * @param {jQuery element} $field ACF input element
     * @returns {array} Altered jQuery datepicker args
     */
    alterPickerArgs: (args, $field) => {

        // Get data attribute element (injected from server)
        const $data = $field.find('.acf-date-picker-data');
        if (!$data.length) {
            return args;
        }

        // Apply minimum date restriction
        const minDate = $data.data('min_date') || false;
        if (minDate) {
            args.minDate = new Date(minDate * 1000);
        }

        // Apply maximum date restriction
        const maxDate = $data.data('max_date') || false;
        if (maxDate) {
            args.maxDate = new Date(maxDate * 1000);
        }

        return args;

    },

    /**
     * Apply datepicker placeholders via data attributes
     * @param {jQuery element} $document Loaded ACF element container
     * @returns void
     */
    applyPickerPlaceholders: ($document) => {

        $document.find('.acf-date-picker, .acf-date-time-picker').each(function() {

            const $field = $(this).closest('.acf-input');

            // Get data attribute element (injected from server)
            const $data = $field.find('.acf-date-picker-data');
            if (!$data.length) {
                return;
            }

            // Apply placeholder
            const placeholder = $data.data('placeholder') || false;
            if (placeholder) {
                $field.find('input.hasDatepicker').attr('placeholder', placeholder);
            }

        });

    },

    /**
     * Escape markup in select2 dropdowns
     * @param {string} markup Select2 dropdown markup
     * @returns {string} Escaped markup
     */
    escapeHTMLDropdownMarkup: (escaped_value, original_value, $select, settings, field, instance) => {
        if(field.data('type') == 'select') {
            return original_value;
        }
        return escaped_value;
    }

};

export default AdvancedCustomFields;